<template>
  <div class="inner-header">
    <img class="inner-header-image" :src="imgUrl">
  </div>
</template>

<script>
export default {
  name: 'InnerHeader',
  props: {
    imgUrl: {
      type: String
    }
  }
};
</script>

<style lang="less">
.inner-header {
  height: 84px;
  &-image {
    width: 100%;
    height: 100%;
  }
}
</style>
